import JSZip from 'jszip';
export { JSZip };

let internalJSZip: JSZip = new JSZip();

export class ZipUtils {
	public static init(): void {
		internalJSZip = new JSZip();
	}

	// tslint:disable-next-line: max-line-length
	public static async addFile(name: string, data: string | ArrayBuffer | Uint8Array | Blob | number[] | NodeJS.ReadableStream | Promise<any>) {
		internalJSZip.file(name, data);
	}

	// tslint:disable-next-line: max-line-length
	public static async addFileToFolder(folder: string, name: string, data: string | ArrayBuffer | Uint8Array | Blob | number[] | NodeJS.ReadableStream | Promise<any>) {
		internalJSZip.folder(folder).file(name, data);
	}

	public static createFolder(name: string): JSZip {
		return internalJSZip.folder(name);
	}

	public static removeFile(name: string): JSZip {
		return internalJSZip.remove(name);
	}

	public static removeFolder(name: string): JSZip {
		return internalJSZip.remove(name);
	}

	// tslint:disable-next-line: max-line-length
	public static loadZip(data: string | ArrayBuffer | Uint8Array | Blob | number[] | NodeJS.ReadableStream, options: object): Promise<JSZip> | undefined {
		if (data === undefined) {
			return;
		}
		return internalJSZip.loadAsync(data);
	}

	public static generateZipBlob(): Promise<Blob> {
		return internalJSZip.generateAsync<"blob">({ type: "blob" });
	}

	public static generateZipIntArray(): Promise<Uint8Array> {
		return internalJSZip.generateAsync<"uint8array">({ type: "uint8array" });
	}

	public static generateZipBase64(): Promise<string> {
		return internalJSZip.generateAsync<"base64">({ type: "base64" });
	}

	public static generateZipBinaryString(): Promise<string> {
		return internalJSZip.generateAsync<"binarystring">({ type: "binarystring" });
	}

	public static generateZipArrayBuffer(): Promise<ArrayBuffer> {
		return internalJSZip.generateAsync<"arraybuffer">({ type: "arraybuffer" });
	}

	public static generateZipArray(): Promise<any> {
		return internalJSZip.generateAsync<"array">({ type: "array" });
	}

	public static generateZipNodeBuffer(): Promise<Buffer> {
		return internalJSZip.generateAsync<"nodebuffer">({ type: "nodebuffer" });
	}

	public static generateZipText(): Promise<string> {
		return internalJSZip.generateAsync<"text">({ type: "text" });
	}
}
